module.exports = __webpack_public_path__ + "static/img/son7_active.0bacbbcd.png";